import React from 'react';

import { IParentPlayerAssessment } from '../../../lib/types';
import {
  RowLabel, RowPrimary, RowSecondary, RowDashSeparator,
} from './parent-player-group-card.styles';

interface IRowContentsProps {
  row: IParentPlayerAssessment;
}

// Assessment name + age group. Desktop: inline with a dash separator. Mobile:
// stacked column (the dash hides via CSS — see RowDashSeparator).
export const RowContents: React.FC<IRowContentsProps> = ({ row }) => (
  <RowLabel>
    <RowPrimary>{row.assessmentName}</RowPrimary>
    <RowDashSeparator>—</RowDashSeparator>
    <RowSecondary>{row.ageGroupName}</RowSecondary>
  </RowLabel>
);
